module.exports = __webpack_public_path__ + "img/3acf55f.svg";